import { GitBranch } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { ConditionNodeEditor } from "./editor";
import { ConditionNodePanel } from "./panel";
import { ConditionNodeProps } from "./types";
import { ConditionNodeDataDto } from "@babackapp/private-api-client/types";


const newNodeDefaultValue: ConditionNodeDataDto = {
  conditions: [],
  operator: "AND",
}

export default registerNode<ConditionNodeProps["data"]>({
  type: "condition",
  name: "workflowsEditor.nodes.condition.title",
  description: "workflowsEditor.nodes.condition.description",
  Icon: GitBranch,
  category: NodeCategory.CONDITION,
  color: "orange",
  editor: {
    component: ConditionNodeEditor,
  },
  configPanel: {
    component: ConditionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue
});

export * from "./types";
export { ConditionNodeEditor } from "./editor";
export { ConditionNodePanel } from "./panel";
